import { Edit } from '@mui/icons-material';
import { Button, Modal, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MyRenderCell } from '../../components';
import { Loading } from '../../components/Loading';
import { IBatchTrackingNumber, createBatchTrackingNumber } from '../../models/batches/batchTrackingNumber';
import { RootState, getBatchTrackingNumber, useAppDispatch, useAppSelector } from '../../redux';
import { MyBoxModal } from '../../styled-components';
import { MyForm } from './components';

export const Details = () => {
    const { id } = useParams();

    const dispatch = useAppDispatch();
    const { isLoading, batchesTrackingNumber } = useAppSelector((state: RootState) => state.batches);
    const [batchesTrackingNumberToEdit, setBatchesTrackingNumberToEdit] = useState(createBatchTrackingNumber({}));

    const [pageSize, setPageSize] = useState<number>(50);

    useEffect(() => {
        if (id)
            dispatch(getBatchTrackingNumber(+id));
    }, [dispatch, id]);

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);

    const onEdit = (batchTrackingNumber: IBatchTrackingNumber) => {
        setBatchesTrackingNumberToEdit(createBatchTrackingNumber(batchTrackingNumber));
        openDialog();
    }

    const Columns: GridColDef[] = [
        {
            field: "action",
            headerName: "Actions",
            width: 70,
            sortable: false,
            align: "right",
            renderCell: (params) => {
                const onClick = (e: React.MouseEvent<HTMLElement>) => {

                    onEdit(params.row as any);
                };
                return (
                    <>
                        <Tooltip title="Edit" >
                            <Button onClick={onClick}><Edit /></Button>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: 'id',
            headerName: 'id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'workOrderId',
            headerName: 'Work Order',
            width: 100,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'trackingNumber',
            headerName: 'Tracking Number',
            width: 200,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'activityCode',
            headerName: 'Activity Code',
            width: 200,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'sendDate',
            headerName: 'Send Date',
            width: 200,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'studentId',
            headerName: 'Student Id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 200,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'lastName',
            headerName: 'Last Name',
            width: 200,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
    ]

    return (
        <div>
            <Loading isLoading={isLoading} />
            <br />
            <Typography variant="h6" component="h2">Work Orders</Typography>
            <br />
            <div style={{ height: "calc(100vh - 250px)", width: '100%', flexGrow: 1 }}>
                <DataGrid
                    rows={batchesTrackingNumber}
                    columns={Columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 50, 100]}
                    columnVisibilityModel={{ id: false, }}
                />
            </div>
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} batchTrackingNumber={batchesTrackingNumberToEdit} idParent={id} />
                </MyBoxModal>
            </Modal>
        </div >
    );
}
